module.exports = __webpack_public_path__ + "static/media/under-armour.c150688c.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/brand-logos/under-armour.png
// module id = 113
// module chunks = 0